import { mockProviders } from '../app/core/mock/mock.providers';

export const environment = {
  production: false,
  defaultLanguage: 'pl',
  languages: ['pl', 'en'],
  apiUrl: 'https://mock.local/api',
  keycloak: {
    url: 'https://mock.local/keycloak',
    // Realm marki Księgowskaz — obsługuje go `gateway` (:8892).
    realm: 'ksiegowskaz',
    // POS loguje się przez Direct Access Grants, czego nie chcemy włączać
    // na kliencie SPA aplikacji webowej — stąd osobny klient publiczny.
    clientId: 'ksiegowskaz-pos',
  },
  useMocks: true,
  mockProviders,
};
